import React from "react"
import { Icon } from "semantic-ui-react"
import settingStore from "stores/settingStore"
import ProductModelBase from "theme/base/shop/ProductModel"
import { action, observable } from "mobx"
import shop from "shop/shop"
import convertBoolean from "util/convertBoolean"

export default class ProductModelArnolds extends ProductModelBase {

  @observable warning = null

  constructor( data ) {
    data = convertBoolean( data )
    super( data )
    this._count = this.count

    const mode = settingStore.get( "orderMode" )
    const isPreorder = this.extraValue.vororder && this.extraValue.vororder !== false
    // Product from PREORDER should be available in SOFORT_ORDER
    // this.available = isPreorder || (!isPreorder && mode === "MODE_AVAILABLE")

    // TODO: only in mode vororder
    switch ( mode ) {
      case "MODE_PREORDER":
        this.available = this.extraValue.vororder;
        break;
      case "MODE_AVAILABLE":
        this.available = Number( this.extraValue.varbestand ) > 0 || this.extraValue.orderable === true
        break;
    }

    if ( this.extraValue.Variante === "null" || !this.extraValue.Variante ) this.extraValue.Variante = "uni"
//    this.extras.sale = this.extraValue.sale
    this.isSale = data.extras.sale.value.value;
//    console.log('CHECK', this.map_id, data.extras.sale.value.value, this.isSale, { data }, { product: this } )

    if ( this.pinfos && this.pinfos.rabatt ) {
      this.salePercent = Number(this.pinfos.rabatt).toFixed(1) + " %"
      console.log('CHECK2', this.map_id, this.pinfos , this.salePercent, { data }, { product: this } )
    }
  }

  validateCount( count ) {
    const mode = settingStore.get( "orderMode" )
    if ( this.extraValue.orderable || mode === "MODE_PREORDER" ) return true
    if ( !this.extraValue.orderable ) {
      return this.stock >= count
    }
  }

  set count( value ) {
    this._count = value
    this.warning = this.createWarnings( value )
  }

  get count() {
    return this._count
  }


  onChange = ( { count } ) => {
    return this.validateCount( count )
  }


  get cartDescription() {
    return this.desc.des
  }

  /**
   *
   * @param size : Number
   * @param currentStock : Number
   * @returns {*}
   */
  getNotice = ( size, currentStock = false ) => {
    let product = this


    const categoryName = this.category && this.category.desc && this.category.desc.short_des.trim()

    const yellow = {}
    const red = {}

    const default_yellow = 1
    const default_red = 0

    // check special conditions
    const yellowCount = 1
    const redCount = 0

    const stock = currentStock || Number( this.stock ) // STOCK für die Variante
    const orderMode = settingStore.get( "orderMode" )


    if ( size === "tiny" ) {

      if ( orderMode === "MODE_PREORDER" ) {
        return notice = <span className={"black-70 ttu"}><Icon color="blue" name="truck"
                                                               title={translate( "beim Lieferanten nachbestellbar" )}/></span>
      }

      if ( stock > yellowCount ) {
        return notice =
          <span className={"black-70 ttu"}><Icon color="green" name="truck" title={translate( "auf Lager" )}/></span>
      }
      if ( product.extraValue.orderable || orderMode === "MODE_PREORDER" ) {
        return notice = <span className={"black-70 ttu"}><Icon color="blue" name="truck"
                                                               title={translate( "beim Lieferanten nachbestellbar" )}/></span>
      }

      if ( stock <= redCount && (!product.extraValue.orderable || orderMode !== "MODE_PREORDER") ) {
        return notice = <span className={"black-70 ttu"}><Icon color="red" name="truck"
                                                               title={translate( "ausverkauft" )}/></span>
      }

      if ( stock <= yellowCount ) {
        return notice = <span className={"black-70 ttu"}><Icon color="yellow" name="truck"
                                                               title={translate( "wenige auf Lager" )}/></span>
      }

      if ( product.extraValue.orderable || orderMode === "MODE_PREORDER" ) {
        return notice = <span className={"black-70 ttu"}><Icon color="blue" name="truck"
                                                               title={translate( "beim Lieferanten nachbestellbar" )}/></span>
      }

      return notice =
        <span className={"black-70 ttu"}><Icon name="truck" title="derzeit nicht lieferbar" circular/></span>
    }


    if ( stock > yellowCount ) {
      return notice =
        <span className={"black-70 ttu"}><Icon color="green" name="truck" title="auf Lager"/> auf Lager </span>
    }

    if ( product.extraValue.orderable || orderMode === "MODE_PREORDER" ) {
      return notice = <span className={"black-70 ttu"}><Icon color="blue" name="truck"
                                                             title={translate( "beim Lieferanten nachbestellbar" )}/>{translate( "beim Lieferanten nachbestellbar" )}</span>
    }

    if ( stock <= redCount && (!product.extraValue.orderable || orderMode !== "MODE_PREORDER") ) {
      return notice = <span className={"black-70 ttu"}><Icon color="red" name="truck"
                                                             title={translate( "ausverkauft" )}/>{translate( "ausverkauft" )} </span>
    }

    if ( stock <= redCount && (product.extraValue.orderable || orderMode === "MODE_PREORDER") ) {
      return notice = <span className={"black-70 ttu"}><Icon color="blue" name="truck"
                                                             title={translate( "beim Lieferanten nachbestellbar" )}/>{translate( "beim Lieferanten nachbestellbar" )}</span>
    }

    if ( stock <= yellowCount ) {
      return notice = <span className={"black-70 ttu"}><Icon color="yellow" name="truck"
                                                             title={translate( "wenige auf Lager" )}/>{translate( "wenige auf Lager" )}</span>
    }

    let notice = <span className={"black-70 ttu"}><Icon name="truck" title={translate( "derzeit nicht lieferbar" )}

                                                        circular/><span>{translate( "derzeit nicht lieferbar" )}</span></span>

    return notice
  }

}



// WEBPACK FOOTER //
// ./src/theme/arnoldsports/shop/ProductModel.js